import axios, { AxiosResponse } from 'axios'
import {
  ChargeExceptionFormData,
  VehicleFormData,
} from '../../components/Supplier/Manage/Vehicles/ManageVehicle'
import { clean } from '../utility/jsonFunctions'
import { getUserToken } from '../utility/localStorageFunctions'
import { getDefaultQueryString } from '../utility/queryFunctions'
import { CongestionZone } from './congestionZonesAPI.types'
import {
  AdditionalCharges,
  ChargeException,
  ChargeRate,
  ChargeRates,
  Services,
  Taxi,
  TaxisAPIResponse,
  VehicleAdditionalCharge,
  VehicleCongestionZone,
  VehicleFixedRoute,
  VehicleService,
} from './taxisAPI.types'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/taxis-api/taxis`

const stripHref = <T>(payload: T): T => {
  if (!payload || typeof payload !== 'object') return payload
  const rest = { ...(payload as any) }
  delete rest.href
  return rest
}

const getTaxis = async (): Promise<AxiosResponse<TaxisAPIResponse>> => {
  console.log(`getTaxis()`)
  const token = await getUserToken('taxis')
  const response = await axios({
    method: 'get',
    url: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
const getTaxisBySupplierId = async (
  supplierId: number,
): Promise<AxiosResponse<TaxisAPIResponse>> => {
  console.log(`getTaxisBySupplierId(${supplierId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(getDefaultQueryString('supplierId', supplierId)),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getTaxisById = async (id: string): Promise<AxiosResponse<Taxi>> => {
  console.log(`getTaxisById(${id})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
const mapChargeRateExceptions = (
  formData: Array<ChargeExceptionFormData>,
): Array<ChargeException> => {
  let mapped: Array<ChargeException> = []
  // console.log('MAP EXCEP ', formData)
  formData?.map((formItem) => {
    if (formItem.value) {
      const mappedItem = {
        chargeExceptionId: +formItem.chargeExceptionId,
        chargeTypeName: formItem.chargeTypeName,
        value: +formItem.value,
      }
      mapped.push(mappedItem)
    }
  })
  return mapped
}
const mapChargeRates = (data: VehicleFormData): Array<ChargeRate> => {
  let mappedChargeRates: any = []
  data?.chargeRates?.map((item) => {
    const mappedException = mapChargeRateExceptions(item.chargeExceptions)
    const toMile = +item.toMile !== 0 ? +item.toMile : undefined
    const chargeRate = {
      fromMile: +item.fromMile,
      toMile: toMile,
      pricePerMile: +item.pricePerMile,
      chargeExceptions: mappedException,
    }
    mappedChargeRates.push(chargeRate)
  })

  return mappedChargeRates
}
const mapCongestionZones = (
  data: VehicleFormData,
): Array<VehicleCongestionZone> => {
  let mappedCongestionZones: Array<VehicleCongestionZone> = []
  data?.congestionZones?.map((item) => {
    if (item.congestionZoneId) {
      const congestionZone = {
        congestionZoneId: item.congestionZoneId,
        applyMarkup: item.applyMarkup,
        applyDefaultPricing: item.applyDefaultPricing,
        ...(item.insideOperatingHoursCharge?.price && {
          insideOperatingHoursCharge: {
            price: parseFloat(`${item.insideOperatingHoursCharge.price}`),
            vATTypeName: item.insideOperatingHoursCharge.vATTypeName,
          },
        }),
        ...(item.outsideOperatingHoursCharge?.price && {
          outsideOperatingHoursCharge: {
            price: parseFloat(`${item.outsideOperatingHoursCharge.price}`),
            vATTypeName: item.outsideOperatingHoursCharge.vATTypeName,
          },
        }),
      }
      mappedCongestionZones.push(congestionZone)
    }
  })

  return mappedCongestionZones
}
const mapAdditionalCharges = (
  data: VehicleFormData,
): Array<VehicleAdditionalCharge> => {
  let mappedAdditionalCharges: Array<VehicleAdditionalCharge> = []
  data?.additionalCharges?.map((item) => {
    if (item.additionalChargeId) {
      const additionalCharge = {
        ...item,
        applyMarkup: item.applyMarkup ? true : false,
        value: +item.value,
      }
      mappedAdditionalCharges.push(additionalCharge)
    }
  })
  console.log('add charges ', mappedAdditionalCharges)
  return mappedAdditionalCharges
}

const mapVehicle = (supplierId: number, data: VehicleFormData): Taxi => {
  console.log('data ', data)

  const minFareChargeExceptions = mapChargeRateExceptions(
    data?.vehicle?.minimumFare?.chargeExceptions,
  )
  // console.log('minFareChargeExceptions ', minFareChargeExceptions)

  const gracePeriodChargeExceptions = mapChargeRateExceptions(
    data?.vehicle?.waitingTime?.gracePeriod?.chargeExceptions,
  )
  // console.log('gracePeriodChargeExceptions ', gracePeriodChargeExceptions)

  const chargingPeriodChargeExceptions = mapChargeRateExceptions(
    data?.vehicle?.waitingTime?.chargingPeriod?.chargeExceptions,
  )
  // console.log('chargingPeriodChargeExceptions ', chargingPeriodChargeExceptions)

  const additionalStopChargeExceptions = mapChargeRateExceptions(
    data?.vehicle?.additionalStop?.chargeExceptions,
  )
  // console.log('additionalStopChargeExceptions ', additionalStopChargeExceptions)

  const waitAndReturnChargeExceptions = mapChargeRateExceptions(
    data?.vehicle?.waitAndReturn?.chargingPeriod?.chargeExceptions,
  )
  // console.log('waitAndReturnChargeExceptions ', waitAndReturnChargeExceptions)
  return {
    supplierId: supplierId,
    vehicleTypeName: data.vehicle.vehicleTypeName,
    capacity: +data.vehicle.capacity,
    fleetSize: +data.vehicle.fleetSize,
    isAvailableForRideHail: data.vehicle.isAvailableForRideHail,
    averageAge: +data.vehicle.averageAge,
    minimumFare: {
      price: +data.vehicle.minimumFare.price,
      chargeExceptions: minFareChargeExceptions,
    },
    waitingTime: {
      freePeriod: +data.vehicle.waitingTime.freePeriod || 0,
      gracePeriod: {
        period: +data.vehicle.waitingTime?.gracePeriod?.period || 0,
        price: +data.vehicle.waitingTime?.gracePeriod?.price || 0,
        chargeExceptions: gracePeriodChargeExceptions,
      },
      chargingPeriod: {
        period: +data.vehicle.waitingTime.chargingPeriod.period,
        price: +data.vehicle.waitingTime.chargingPeriod.price,
        chargeExceptions: chargingPeriodChargeExceptions,
      },
    },
    ...(data?.vehicle?.additionalStop?.price && {
      additionalStop: {
        price: +data.vehicle.additionalStop.price,
        chargeExceptions: additionalStopChargeExceptions,
      },
    }),
    ...(data?.vehicle?.waitAndReturn?.chargingPeriod?.price && {
      waitAndReturn: {
        discount: +data.vehicle.waitAndReturn?.discount,
        chargingPeriod: {
          period: +data.vehicle.waitAndReturn.chargingPeriod.period,
          price: +data.vehicle.waitAndReturn.chargingPeriod.price,
          chargeExceptions: waitAndReturnChargeExceptions,
        },
      },
    }),
    chargeRates: mapChargeRates(data),
    ...(data?.congestionZones && {
      congestionZones: mapCongestionZones(data),
    }),
    ...(data?.additionalCharges && {
      additionalCharges: mapAdditionalCharges(data),
    }),
  }
}

const createTaxi = async (
  supplierId: number,
  formData: VehicleFormData['vehicle'],
) => {
  console.log(`createTaxi(supplierId: ${supplierId})`)
  clean(formData)
  const mappedTaxi = mapVehicle(supplierId, formData)
  console.log('Mapped taxi ', mappedTaxi)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'post',
    url: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...mappedTaxi,
      },
    },
  })
  return response
}

const updateTaxi = async (
  taxiId: number,
  formData: VehicleFormData['vehicle'],
) => {
  clean(formData)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'patch',
    url: BASE_URL.concat(`/${taxiId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: stripHref(formData),
    },
  })
  return response
}

const deleteTaxi = async (id: number) => {
  console.log(`deleteTaxi(${id})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getServiceByTaxiId = async (
  taxiId: number,
): Promise<AxiosResponse<Services>> => {
  console.log(`getServicesByTaxiId(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/services`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createService = async (taxiId: number, service: VehicleService) => {
  clean(service)
  console.log(`createService(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${taxiId}/services`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...service,
      },
    },
  })
  return response
}

const getServiceByServiceId = async (
  taxiId: number,
  serviceId: number,
): Promise<AxiosResponse<Services>> => {
  console.log(`getServiceByServiceId(${taxiId}, ${serviceId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/services/${serviceId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const deleteService = async (taxiId: number, serviceId: number) => {
  console.log(`deleteService(${taxiId}, ${serviceId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiId}/services/${serviceId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getChargeRatesByTaxiId = async (
  taxiId: number,
): Promise<AxiosResponse<ChargeRates>> => {
  console.log(`getChargeRatesByTaxiId(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/chargeRates`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createChargeRate = async (
  taxiId: number,
  chargeRates: ChargeRate | ChargeRate[],
) => {
  const payload = Array.isArray(chargeRates) ? chargeRates : [chargeRates]
  payload.forEach((rate) => clean(rate))
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${taxiId}/chargeRates`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: payload,
    },
  })
  return response
}

const getChargeRatesByChargeRateId = async (
  taxiId: number,
  chargeRateId: number,
): Promise<AxiosResponse<ChargeRates>> => {
  console.log(`getChargeRatesByChargeRateId(${taxiId}, ${chargeRateId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/chargeRates/${chargeRateId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const updateChargeRate = async (
  taxiId: number,
  chargeRateId: number,
  chargeRate: ChargeRate,
) => {
  clean(chargeRate)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${taxiId}/chargeRates/${chargeRateId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: stripHref(chargeRate),
    },
  })
  return response
}

const deleteChargeRate = async (taxiId: number, serviceId: number) => {
  console.log(`deleteChargeRate(${taxiId}, ${serviceId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiId}/chargeRates/${serviceId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getAdditionalChargesByTaxiId = async (
  taxiId: number | undefined,
): Promise<AxiosResponse<AdditionalCharges>> => {
  console.log(`getAdditionalChargesByTaxiId(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/additionalCharges`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createAdditionalCharge = async (
  taxiId: number,
  additionalCharge: VehicleAdditionalCharge,
) => {
  clean(additionalCharge)
  console.log(`createVehicle(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${taxiId}/additionalCharges`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...additionalCharge,
      },
    },
  })
  return response
}

const getAdditionalChargesByAdditionalChargeId = async (
  taxiId: number,
  additionalChargeId: number,
): Promise<AxiosResponse<ChargeRates>> => {
  console.log(`getChargeRatesByChargeRateId(${taxiId}, ${additionalChargeId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/additionalCharges/${additionalChargeId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const deleteAdditionalCharge = async (
  taxiId: number,
  additionalChargeId: number,
) => {
  console.log(`deleteChargeRate(${taxiId}, ${additionalChargeId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiId}/additionalCharges/${additionalChargeId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getCongestionZonesByTaxiId = async (
  taxiId: number | undefined,
): Promise<AxiosResponse<{ value: VehicleCongestionZone[] }>> => {
  console.log(`getCongestionZonesByTaxiId(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/congestionZones`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createCongestionZone = async (
  taxiId: number,
  congestionZone: CongestionZone,
) => {
  clean(congestionZone)
  console.log(`createCongestionZone(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${taxiId}/congestionZones`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...congestionZone,
      },
    },
  })
  return response
}

const getCongestionZoneById = async (
  taxiId: number,
  congestionZoneId: number,
): Promise<AxiosResponse<CongestionZone>> => {
  console.log(`getServiceByServiceId(${taxiId}, ${congestionZoneId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/congestionZones/${congestionZoneId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const deleteCongestionZone = async (
  taxiId: number,
  congestionZoneId: number,
) => {
  console.log(`deleteService(${taxiId}, ${congestionZoneId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiId}/congestionZones/${congestionZoneId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getFixedRoutesByTaxiId = async (
  taxiId: number | undefined,
): Promise<AxiosResponse<{ value: VehicleFixedRoute[] }>> => {
  console.log(`getFixedRoutesByTaxiId(${taxiId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/fixedRoutes`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const createFixedRoute = async (
  vehicleId: number,
  fixedRoute: VehicleFixedRoute,
) => {
  const token = await getUserToken('taxis')

  clean(fixedRoute)
  const response = await axios({
    method: 'post',
    url: BASE_URL?.concat(`/${vehicleId}/fixedRoutes`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: {
        ...fixedRoute,
      },
    },
  })
  return response
}

const getFixedRouteById = async (
  taxiId: number,
  fixedRouteId: number,
): Promise<AxiosResponse<VehicleFixedRoute>> => {
  console.log(`getFixedRouteById(${taxiId}, ${fixedRouteId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${taxiId}/fixedRoutes/${fixedRouteId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const updateFixedRoute = async (
  taxiId: number,
  fixedRouteId: number,
  payload: VehicleFixedRoute,
) => {
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${taxiId}/fixedRoutes/${fixedRouteId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: stripHref(payload),
    },
  })
  return response
}

const deleteFixedRoute = async (taxiId: number, fixedRouteId: number) => {
  console.log(`deleteFixedRoute(${taxiId}, ${fixedRouteId})`)
  const token = await getUserToken('taxis')

  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(`/${taxiId}/fixedRoutes/${fixedRouteId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

export const taxisAPI = {
  getTaxis,
  getTaxisBySupplierId,
  getTaxisById,
  createTaxi,
  updateTaxi,
  deleteTaxi,
  getServiceByTaxiId,
  createService,
  getServiceByServiceId,
  deleteService,
  getChargeRatesByTaxiId,
  createChargeRate,
  updateChargeRate,
  getChargeRatesByChargeRateId,
  deleteChargeRate,
  getAdditionalChargesByTaxiId,
  createAdditionalCharge,
  getAdditionalChargesByAdditionalChargeId,
  deleteAdditionalCharge,
  getCongestionZonesByTaxiId,
  createCongestionZone,
  getCongestionZoneById,
  deleteCongestionZone,
  getFixedRoutesByTaxiId,
  createFixedRoute,
  getFixedRouteById,
  updateFixedRoute,
  deleteFixedRoute,
}
